export default [
  {
    path: '/pullNew',
    component: () => import('@views/pullNew/index'),
    name: 'pullNewIndex',
    meta: {
      isLogin: false,
      isFooterShow: false,
      title: '包拯'
    }
  },
  {
    path: '/customPage',
    component: () => import('@views/pullNew/customPage375'),
    name: 'customPageIndex',
    meta: {
      isLogin: false,
      isFooterShow: false,
      title: '包拯'
    }
  },
  {
    path: '/sendFeedback',
    component: () => import('@views/pullNew/sendFeedback'),
    name: 'sendFeedbackIndex',
    meta: {
      isLogin: false,
      isFooterShow: false,
      title: '包拯'
    }
  },
  {
    path: '/sendFeedbackNo',
    component: () => import('@views/pullNew/sendFeedbackNo'),
    name: 'sendFeedbackNoIndex',
    meta: {
      isLogin: false,
      isFooterShow: false,
      title: '包拯'
    }
  },
]